<template>
  <div class="container">
    <div class="title">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>账单管理</el-breadcrumb-item>
        <el-breadcrumb-item>账单核对</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="content">
      <el-tabs v-model="activeTab" type="card">
        <el-tab-pane label="外部核对" name="external">
          <external-check />
        </el-tab-pane>
        <el-tab-pane label="内部核对" name="internal">
          <internal-check />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import InternalCheck from './internalCheck.vue';
import ExternalCheck from './externalCheck.vue';

export default {
  name: 'BillCheck',
  components: {
    InternalCheck,
    ExternalCheck,
  },
  data() {
    return {
      activeTab: 'external',
    };
  },
};
</script>

<style lang="less" scoped>
.container {
  padding: 20px;

  .content {
    background-color: #fff;
    border-radius: 4px;

    .el-tabs {
      padding: 20px 0;
    }
  }
}
</style>
